import { Icon, Tooltip } from '@customerio/pluma-components/react';

export interface ExpandCollapseButtonProps {
  isCollapsed: boolean;
  onClick: () => void;
}

export default function ExpandCollapseButton(props: ExpandCollapseButtonProps) {
  return (
    <Tooltip placement="right" content={props.isCollapsed ? 'Expand' : 'Collapse'} isCustom={true}>
      {(context) => (
        <button
          className="main-nav__expand-collapse-button"
          aria-label={props.isCollapsed ? 'Expand navigation' : 'Collapse navigation'}
          onClick={props.onClick}
          ref={context.reference.setReference}
          {...context.reference.getReferenceProps()}
        >
          <Icon
            name={props.isCollapsed ? 'chevron-right-double' : 'chevron-left-double'}
            color="subtle"
            flexShrink="0"
          />
        </button>
      )}
    </Tooltip>
  );
}
